export const Experiments = {
  starting_donation_on_frp_with_amount_page_mobile:
    'starting_donation_on_frp_with_amount_page_mobile',
  starting_donation_on_frp_with_amount_page_desktop:
    'starting_donation_on_frp_with_amount_page_desktop',
  b2c_054_show_hide_fitness_totaliser: 'b2c_054_show_hide_fitness_totaliser',
  b2c_059_donate_to_yourself_v3: 'b2c_059_donate_to_yourself_v3',
};
